import React, { useEffect, useState } from 'react';

import useGlobalState from 'Hooks/useGlobalState';

import CircularLoader from 'Components/Loaders/CircularLoader';
import SortableSearchableTable from 'Components/ui/SortableSearchableTable';
import { getDevices, getScheduledEventRulesByParent, addScheduledEventRule, updateScheduledEventRule, deleteScheduledEventRuleByUuid } from 'Data/api';
import CheckboxGroup from 'Components/ui/CheckBoxGroup';
import { ReactComponent as ArrowIcon } from "assets/arrow.svg";
import { ReactComponent as DeleteIcon } from "assets/delete.svg";
import adminStyles from 'Styles/adminStyles';

import { CardHeader, CardContent, Card, Container, Typography, TextField, Grid } from '@mui/material';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import BasicTable from 'Components/ui/BasicTable';

const AdminNotifications = () => {
	// const theme = useTheme();
	const classes = adminStyles();
	
	const [globalState, ] = useGlobalState();
	const { user } = globalState;

	const [loading, setLoading] = useState(true);
	const [deviceDialogOpen, setDeviceDialogOpen] = useState(false);
	const [savingEventRule, setSavingEventRule] = useState(false);
	const [deviceSelected, setDeviceSelected] = useState([]);
	const [deviceList, setDeviceList] = useState([]);
	const [dataPoints, setDataPoints] = useState([]);
	const [scheduledRules, setScheduledRules] = useState([]);
	const [scheduledRulesList, setScheduledRulesList] = useState([]);
	const [notificationName, setNotificationName] = useState('');
	const [notificationCreated, setNotificationCreated] = useState('');
	const [periodGrade, setPeriodGrade] = useState('E');
	const [activePeriod, setActivePeriod] = useState('today');
	const [nodataperiod, setNodataperiod] = useState('today');
	const [nodataNotification, setNodataNotification] = useState([]);
	const [eventId, setEventId] = useState(null);
	const [eventUUID, setEventUUID] = useState(null);

	const deviceColumns = [
		{ id: "name", label: "Navn", sortable: true },
		{ id: "title", label: "Title", sortable: true },
		{ id: "building", label: "Bygning", sortable: true },
		{ id: "description", label: "Beskrivelse", sortable: true }
	];

	const scheduledRulesColumns = [
		{ id: "name", label: "Navn", sortable: true },
		{ id: "alerts", label: "Alarmer", sortable: false },
		{ id: "created", label: "Oprettet", sortable: true }
	];

	// Load data
	useEffect(() => {
		const fetchData = async () => {
			let devices = await getDevices();
			console.log('AdminDevices - useEffect - devices', devices);
			let newDevices = devices.map(device => ({
				id: device.uuid,
				name: device.name,
				uuname: device.uuname,
				building: device.registry ? device.registry.name : 'Unknown',
				title: device.metadata.title || 'No Title',
				description: device.metadata.description || 'No Description'
			}));
			setDeviceList(newDevices);
			let rules = await getScheduledEventRulesByParent(user.uuid);
			console.log('Fetched scheduled event rules:', rules);
			if (!rules || !rules.result) {
				setScheduledRulesList([]);
				setScheduledRules([]);
				setLoading(false);
				return;
			}
			let mappedRules = rules.result.map(rule => {
				console.log('Date:', new Date(rule.config.created).toLocaleString('da-DK'));
				return {
					id: rule.id,
					name: rule.config.name,
					created: (rule.config.created) ? new Date(rule.config.created).toLocaleString('da-DK') : '',
					alerts: rule.condition.alert.map(alert => { 
						console.log('Mapping alert:', alert, Object.keys(alert));
						return alertNameFromCode(Object.keys(alert)[0]);
					}).join(', ') + (rule.condition.nodataNotification ? ', Afbrudt enhed' : '')
				}
			});
			setScheduledRulesList(mappedRules);
			setScheduledRules(rules);
			setLoading(false);
		}
		fetchData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// Handle device dialog open/close
	const handleDeviceDialogOpen = () => {
		setDeviceDialogOpen(true);
	};
	const handleDeviceDialogClose = () => {
		setDeviceDialogOpen(false);
	};
	const handleSelectionChange = (selectedIds) => {
		setDeviceSelected(selectedIds);
	};
	const handleNotificationSelect = (id, row) => {
		let a = scheduledRules.result.filter(rule => rule.id === row.id)
		setEventId(a[0].id);
		setEventUUID(a[0].uuid);
		let selectedDevices = a[0].condition.devices.map(devUuname => {
			let device = deviceList.find(d => d.uuname === devUuname);
			return device ? device.id : null;
		}).filter(id => id);
		setDeviceSelected(selectedDevices);
		let selectedDataPoints = a[0].condition.alert.map(alert => {
			return Object.keys(alert)[0];
		});
		// console.log('Selected datapoints from rule:', selectedDataPoints);
		setDataPoints(selectedDataPoints);
		setPeriodGrade(a[0].condition.alert[0][Object.keys(a[0].condition.alert[0])[0]]);
		setActivePeriod(a[0].condition.period);
		setNotificationName(a[0].config.name);
		setNotificationCreated(a[0].config.created);
		setNodataperiod(a[0].condition.nodataperiod);
		if (a[0].condition.nodataNotification === true) {
			setNodataNotification(['nodataNotification']);
		} else {
			setNodataNotification([]);
		}
		console.log('Full rule data:', a[0]);

	}
	const newNotification = () => {
		setEventId(null);
		setEventUUID(null);
		setDeviceSelected([]);
		setDataPoints([]);
		setPeriodGrade('E');
		setActivePeriod('today');
		setNotificationName('');
		setNotificationCreated('');
		setNodataperiod('today');
		setNodataNotification([]);
	};
	const gradeColor = (grade) => {
		const colors = {
			'A': '#4672D5',
			'B': '#5F8BE0',
			'C': '#7BA5EA',
			'D': '#9DBDEF',
			'E': '#E8A191',
			'F': '#FC5F5B',
			'G': '#D94343'
		}
		return colors[grade]
	}
	const alertNameFromCode = (code) => {
		const names = {
			'co2m': 'CO₂',
			'humi': 'Fugt',
			'temp': 'Temperatur'
		}
		return names[code] || code;
	}
	const handleDeleteNotification = async (uuid) => {
		if (!window.confirm('Er du sikker på, at du vil slette denne notifikations-alarm?')) {
			return;
		}
		console.log('Deleting notification with UUID:', uuid);
		setLoading(true);
		const result = await deleteScheduledEventRuleByUuid(uuid);
		console.log('Delete result:', result);
		if (result.result !== true) {
			alert('Der opstod en fejl under sletning af notifikations-alarmen. Prøv igen.');
			setLoading(false);
			return;
		}
		alert('Notifikations-alarmen er slettet.');
		// Reset form
		newNotification();
		// Refresh scheduled rules list
		let rules = await getScheduledEventRulesByParent(user.uuid);
		if (!rules || !rules.result) {
			setScheduledRulesList([]);
			setScheduledRules([]);
			setLoading(false);
			return;
		}
		let mappedRules = rules.result.map(rule => ({
			id: rule.id,
			name: rule.config.name,
			created: (rule.config.created) ? new Date(rule.config.created).toLocaleString('da-DK') : '',
			alerts: rule.condition.alert.map(alert => { 
				return alertNameFromCode(Object.keys(alert)[0]);
			}).join(', ') + (rule.condition.nodataNotification ? ', Afbrudt enhed' : '')
		}));
		setScheduledRulesList(mappedRules);
		setScheduledRules(rules);
		setLoading(false);
	};
	const saveEventRule = async () => {
		if (deviceSelected.length === 0) {
			alert('Vælg venligst mindst én sensor for at generere en eksport.');
			return;
		}
		if (dataPoints.length === 0) {
			alert('Vælg venligst mindst ét datapunkt for at generere en eksport.');
			return;
		}
		const rule = {
			"id": eventId,
			"uuid": eventUUID,
			"subscriptionId": 1,
			"parentOrg": user.org.uuid,
			"parentUser": user.uuid,
			"cloudFunction": 242,
			"condition": {
				devices: deviceSelected.map(id => {
					const device = deviceList.find(d => d.id === id);
					return device ? device.uuname : null;
				}),
				nodataperiod: nodataperiod,
				nodataNotification: (nodataNotification.length > 0) ? true : false,
				period: activePeriod,
				alert: dataPoints.map(dp => {
					let r = {}
					r[dp] = periodGrade;
					return r;
				})
			},
			"config": {
				"name": notificationName,
				"created": (notificationCreated) ? notificationCreated : new Date().toISOString(),
				"actionHost": "onboarding.aabn.io",
				"actionType": 1,
				"actionConfig": {
					"noProcess": true,
					"message": {
						"body": "",
						"subject": "Dit indeklima kræver opmærksomhed - " + notificationName
					},
					"recipients": [
							{
									"name": user.firstName + ' ' + user.lastName,
									"email": user.email
							}
					]
				}
			}
		}
		console.log(rule);
		setSavingEventRule(true);
		let result;
		if (eventId === null) {
			// New rule
			result = await addScheduledEventRule(rule);
		} else {
			// Update existing rule
			result = await updateScheduledEventRule(rule);
		}
		console.log('Save event rule result:', result);
		if (result.result === false) {
			alert('Der opstod en fejl under gemning af notifikations-alarmen. Prøv igen.');
			setSavingEventRule(false);
			return;
		}
		alert('Notifikations-alarmen er gemt.');
		// Reset form
		newNotification();
		// Refresh scheduled rules list
		let rules = await getScheduledEventRulesByParent(user.uuid);
		if (!rules || !rules.result) {
			setScheduledRulesList([]);
			setScheduledRules([]);
			setSavingEventRule(false);
			return;
		}
		let mappedRules = rules.result.map(rule => ({
			id: rule.id,
			name: rule.config.name,
			created: (rule.config.created) ? new Date(rule.config.created).toLocaleString('da-DK') : '',
			alerts: rule.condition.alert.map(alert => { 
				return alertNameFromCode(Object.keys(alert)[0]);
			}).join(', ') + (rule.condition.nodataNotification ? ', Afbrudt enhed' : '')
		}));
		setScheduledRulesList(mappedRules);
		setScheduledRules(rules);
		setSavingEventRule(false);
	};

	return (
		!loading ?
			<>
				<Container maxWidth="lg" style={{ padding: '20px', marginBottom: '100px' }}>
					<Card>
						<CardHeader title="Mine notifikationer" action={<Button color="admin" variant='contained' onClick={newNotification}>Tilføj notifikation</Button>} />
						<CardContent>
							<BasicTable data={scheduledRulesList} tableColumns={scheduledRulesColumns} onSelectionChange={handleNotificationSelect} />
						</CardContent>
					</Card>
					<Container maxWidth="lg" style={{ padding: '20px' }}>
						<>
							{ eventId !== null ? 
								<> <Typography variant="h4" gutterBottom>Rediger notifikation <Button onClick={() => handleDeleteNotification(eventUUID) }><DeleteIcon /></Button></Typography>  </>
							:
								<Typography variant="h4" gutterBottom>Ny notifikation</Typography>
							}
						<Typography>Læs vores guide til at lave en alarm</Typography>
						</>
					</Container>
					{ !savingEventRule ? <>
					<Card>
						<CardHeader title="Vælg sensorer" subheader="Vælg hvilke sensorer, der skal eksporteres fra." />
						<CardContent>
							<Button color='admin' onClick={handleDeviceDialogOpen} variant="contained" >
								Vælg sensorer
							</Button>
							{deviceSelected.length > 0 && (
								<>
									<Typography variant="body2" color="textSecondary" style={{ marginTop: '10px' }}>
										{deviceSelected.length} sensor(er) valgt.
									</Typography>
									<Typography variant="body2" color="textSecondary" style={{ marginTop: '10px' }}>
										{deviceSelected.map(id => {
											const device = deviceList.find(d => d.id === id);
											// console.log('Finding name for device ID:', id, device);
											return device ? device.title + ' (' + device.name + ')' : null;
											// return device ? device.name : null;
										}).filter(name => name).join(', ')}
									</Typography>
								</>
							)}

						</CardContent>
					</Card>
					<Card style={{ marginTop: '20px' }}>
						<CardHeader title="Vælg notifikationsalarmer" subheader="Vælg hvilke sensorer, du vil have notifikation fra." />
						<CardContent>
							<CheckboxGroup
								options={[
									{ label: 'CO₂, ppm', value: 'co2m' },
									{ label: 'Luftfugtighed, %', value: 'humi' },
									{ label: 'Temperatur, °C', value: 'temp' },
								]}
								onChange={(selected) => { setDataPoints(selected); console.log('Selected datapoints:', selected); }}
								initialSelected={dataPoints}
								label="Vælg notifikationer"
							/>
						</CardContent>
					</Card>
					<Card style={{ marginTop: '20px' }}>
						<CardHeader title="Vælg grænseværdi" subheader="Send en e-mail notifikation når grænseværdien for parameteren er lig med eller værre end:" />
						<CardContent>

							<Grid item textAlign={'center'} xs={12} style={{ marginBottom: '10px' }}>
								<div onClick={ () => setPeriodGrade('A')} className={classes.grade} style={{ backgroundColor: gradeColor('A') }}><div>A</div><div><ArrowIcon className={ (periodGrade === 'A') ? classes.gradeArrowSelected : classes.gradeArrow } /></div></div>
								<div onClick={ () => setPeriodGrade('B')} className={classes.grade} style={{ backgroundColor: gradeColor('B') }}><div>B</div><div><ArrowIcon className={ (periodGrade === 'B') ? classes.gradeArrowSelected : classes.gradeArrow } /></div></div>
								<div onClick={ () => setPeriodGrade('C')} className={classes.grade} style={{ backgroundColor: gradeColor('C') }}><div>C</div><div><ArrowIcon className={ (periodGrade === 'C') ? classes.gradeArrowSelected : classes.gradeArrow } /></div></div>
								<div onClick={ () => setPeriodGrade('D')} className={classes.grade} style={{ backgroundColor: gradeColor('D') }}><div>D</div><div><ArrowIcon className={ (periodGrade === 'D') ? classes.gradeArrowSelected : classes.gradeArrow } /></div></div>
								<div onClick={ () => setPeriodGrade('E')} className={classes.grade} style={{ backgroundColor: gradeColor('E') }}><div>E</div><div><ArrowIcon className={ (periodGrade === 'E') ? classes.gradeArrowSelected : classes.gradeArrow } /></div></div>
								<div onClick={ () => setPeriodGrade('F')} className={classes.grade} style={{ backgroundColor: gradeColor('F') }}><div>F</div><div><ArrowIcon className={ (periodGrade === 'F') ? classes.gradeArrowSelected : classes.gradeArrow } /></div></div>
								<div onClick={ () => setPeriodGrade('G')} className={classes.grade} style={{ backgroundColor: gradeColor('G') }}><div>G</div><div><ArrowIcon className={ (periodGrade === 'G') ? classes.gradeArrowSelected : classes.gradeArrow } /></div></div>
							</Grid>
							<Grid item textAlign={'center'} xs={12} className={classes.topSpace}>
								<button className={classes.buttonDisabled} disabled>I en periode på</button>
								<span style={{ display: 'inline-block' }}>
									<button className={activePeriod === 'today' ? classes.buttonActive : classes.buttonInactive} onClick={() => setActivePeriod('today')}>1 dag</button>
									<button className={activePeriod === 'week' ? classes.buttonActive : classes.buttonInactive} onClick={() => setActivePeriod('week')}>7 dage</button>
									<button className={activePeriod === 'month' ? classes.buttonActive : classes.buttonInactive} onClick={() => setActivePeriod('month')}>30 dage</button>
								</span>
							</Grid>
							<Typography variant="body2" color="textSecondary" style={{ marginTop: '10px' }}>
								<a rel="noreferrer" href="https://aabn.io/blogs/helpcenter/forsta-abns-indeklimamaerke" target='_blank' style={{ color: '#4672D5' }}>Læs hvilke parametre A-G græseværdierne er sat til.</a>
							</Typography>
						</CardContent>
					</Card>
					<Card style={{ marginTop: '20px' }}>
						<CardHeader title="Notifikation om afbrudt enhed(er)" subheader="Send en e-mail notifikation når de valgte enheder ikke været aktive:" />
						<CardContent>
							<Grid item textAlign={'center'} xs={12} >
								<button className={classes.buttonDisabled} disabled>I en periode på</button>
								<span style={{ display: 'inline-block' }}>
									<button className={nodataperiod === 'today' ? classes.buttonActive : classes.buttonInactive} onClick={() => setNodataperiod('today')}>1 dag</button>
									<button className={nodataperiod === 'week' ? classes.buttonActive : classes.buttonInactive} onClick={() => setNodataperiod('week')}>7 dage</button>
									<button className={nodataperiod === 'month' ? classes.buttonActive : classes.buttonInactive} onClick={() => setNodataperiod('month')}>30 dage</button>
								</span>
							</Grid>
							<Grid item textAlign={'center'} xs={12} className={classes.topSpace}>
								<CheckboxGroup
									options={[
										{ label: 'Aktivér notifikation', value: 'nodataNotification' },
									]}
									onChange={(selected) => { setNodataNotification(selected); console.log('Selected nodata:', selected); }}
									initialSelected={nodataNotification}
									label="Aktivér notifikation"
								/>
							</Grid>
						</CardContent>
					</Card>

					<Card style={{ marginTop: '20px' }}>
						<CardHeader title="Navngiv notifikations-alarmen" subheader="Giv din alarm et navn så du i fremtiden kan huske den." />
						<CardContent>
							<TextField
								fullWidth
								label="Angiv navn"
								variant="outlined"
								value={notificationName}
								onChange={(e) => setNotificationName(e.target.value)}
							/>
						</CardContent>
					</Card>
					<Container maxWidth="lg" style={{ textAlign: 'center', padding: '20px', marginBottom: '100px' }}>
						<Button onClick={saveEventRule} color='admin' variant='contained' >
							Bekræft alarm
						</Button>
					</Container>
					</> : <CircularLoader />}
				</Container>


				<Dialog open={deviceDialogOpen} fullWidth={true} maxWidth="xl" >
					<DialogTitle>Vælg sensorer</DialogTitle>
					<DialogContent>
						<><SortableSearchableTable data={deviceList} tableColumns={deviceColumns} onSelectionChange={handleSelectionChange} initialSelected={deviceSelected} /></>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleDeviceDialogClose} color="admin" variant="contained" >
							Luk
						</Button>
					</DialogActions>
				</Dialog>

			</> : <CircularLoader />
	);
};

export default AdminNotifications;